import Vue from 'vue';
import Router from 'vue-router';
// import Layout from '../layout';

Vue.use(Router);


export const constantRouterMap = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/index',
        component: () => import('../pages/index')
    },
    {
        path: '/product',
        component: () => import('../pages/product')
    },
    {
        path: '/news',
        component: () => import('../pages/news')
    },
    {
        path: '/movie?sort=0',
        component: () => import('../pages/news2')
    },
    {
        path: '/movie?sort=1',
        component: () => import('../pages/news3')
    },
    {
        path: '/movie?sort=2',
        component: () => import('../pages/news4')
    },
    {
        path: '/movie?sort=3',
        component: () => import('../pages/news5')
    },
    {
        path: '/news2',
        component: () => import('../pages/news2')
    },
    {
        path: '/news3',
        component: () => import('../pages/news3')
    },
    {
        path: '/news4',
        component: () => import('../pages/news4')
    },
    {
        path: '/news5',
        component: () => import('../pages/news5')
    },
    {
        path: '/newsdetail',
        component: () => import('../pages/newsdetail')
    },
    
    {
        path: '/about',
        component: () => import('../pages/aboutall')
    },
    {
        path: '/contact',
        component: () => import('../pages/contact')
    },
    {
        path: '/login',
        component: () => import('../pages/login')
    },
    {
        path: '/joinus',
        component: () => import('../pages/joinus')
    },
    {
        path: '/aboutteam',
        component: () => import('../pages/aboutteam')
    },
    {
        path: '/production',
        component: () => import('../pages/production')
    },
    {
        path: '/study',
        component: () => import('../pages/study')
    },
    {
        path: '/aboutend',
        component: () => import('../pages/aboutend')
    },
    // {
    //     path: '/row',
    //     component: () => import('../pages/Row')
    // },
    // {
    //     path: '/icons',
    //     component: () => import('../pages/Icons')
    // },
    // {
    //     path: '/button',
    //     component: () => import('../pages/Button')
    // },
];

const createRouter = () => new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
});
const router = createRouter();
router.beforeEach((to, from, next) => {
    document.title =  '宁波天鑫金属软管有限公司-宁波天鑫仪表有限公司';
    next();
  });
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;
